module.exports = __webpack_public_path__ + "static/media/1.ccd4b9c9.jpg";